import { YOUTUBE_LINK_START } from '@yme/utils/constants';
import { YOUTUBE_PLAYLIST_EMBED_PART } from './constants';
export function buildQueryParam({ paramsList }) {
    return paramsList.join('&');
}
export function getFullSourcePath({ youtubeId, queryParam, }) {
    return queryParam
        ? `${YOUTUBE_LINK_START}/${youtubeId}?${queryParam}`
        : `${YOUTUBE_LINK_START}/${youtubeId}`;
}
export function getFullSourcePathForPlaylist({ youtubeId, queryParam }) {
    return queryParam
        ? `${YOUTUBE_LINK_START}/${YOUTUBE_PLAYLIST_EMBED_PART}${youtubeId}&${queryParam}`
        : `${YOUTUBE_LINK_START}/${YOUTUBE_PLAYLIST_EMBED_PART}${youtubeId}`;
}
